
// import React, { useState } from "react";
// import "./Header.css";
// import { useLocation, useNavigate } from "react-router-dom";
// import { Dropdown, Menu } from "antd";
// import Logo from "../image/logo.png";
// import UserImg from "../image/userImg.png";

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
  
//   const useQuery = () => {
//     return new URLSearchParams(useLocation().search);
//   };

//   const query = useQuery();
//   const tokenn = query.get("token");
//   localStorage.setItem("token", tokenn);
//   const token = localStorage.getItem("token");
//   const username = localStorage.getItem("username") || "User"; // Get username from localStorage or set a default

//   const navigate = useNavigate();

//   const handleLogout = async () => {
//     try {
//       localStorage.removeItem("token");
//       localStorage.removeItem("username");
//       window.location.href = "https://www.tattqr.com";
//     } catch (error) {
//       console.log("error is", error);
//     }
//   };

//   const handleToggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const menu = (
//     <Menu>
//       <Menu.Item key="profile" onClick={() => navigate("/profile")}>
//         Profile
//       </Menu.Item>
//       <Menu.Item key="logout" onClick={handleLogout}>
//         Logout
//       </Menu.Item>
//     </Menu>
//   );

//   return (
//     <div className="navbar">
//       <div className="logoDiv">
//         <img src={Logo} className="logo" alt="Logo" style={{ width: "100px" }} />
//       </div>
//       <div className={`nav-items ${isMenuOpen ? "active" : ""}`}>
//         <ul className="nav-items-list">
//           <li className="nav-item" onClick={() => navigate("/Home")}>Home</li>
//           <li className="nav-item" onClick={() => navigate("/about-us")}>About</li>
//           <li className="nav-item" onClick={() => navigate("/how-it-works")}>How It Works</li>
//           <li className="nav-item" onClick={() => navigate("/testimonials")}>Testimonials</li>
//           <li className="nav-item" onClick={() => navigate("/contact-us")}>Contact Us</li>
//           <li className="nav-item login" onClick={() => navigate("/")}>Login</li>
//         </ul>
//       </div>

//       {token && (token !== null && token !== "null") ? (
//         <Dropdown overlay={menu} trigger={['click']}>
//           <div className="user-menu">
//             <span className="username">{username}</span>
//             <img src={UserImg} alt="user" className="dummy-icon" /> {/* Placeholder for user icon */}
//           </div>
//         </Dropdown>
//       ) : (
//         <span></span>
//       )}
//     </div>
//   );
// };

// export default Header;


import React, { useState } from "react";
import "./Header.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Dropdown, Menu } from "antd";
import { toast } from "react-toastify";
import Logo from "../image/logo.png";
import UserImg from "../image/userImg.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const query = useQuery();
  const tokenn = query.get("token");
  if (tokenn) {
    localStorage.setItem("token", tokenn);
  }
  const token = localStorage.getItem("token");
  const isTokenValid = token && token !== "null" && token !== "undefined";

  const usersName = query.get("username");
  if (usersName) {
    localStorage.setItem("username", usersName);
  }
  const username = localStorage.getItem("username") || "User"; // Get username from localStorage or set a default

  const navigate = useNavigate();
  const location = useLocation(); // Get the current location

  const handleLogout = async () => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      window.location.href = "https://www.tattqr.com";
    } catch (error) {
      console.log("error is", error);
      toast.error("Unable to log out right now. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const handleToggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const menu = (
    <Menu>
      <Menu.Item key="profile" onClick={() => navigate("/profile")}>
        Profile
      </Menu.Item>
      <Menu.Item key="logout" onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="navbar">
      <div className="logoDiv">
        <img src={Logo} className="logo" alt="Logo" style={{ width: "100px" }} />
      </div>
      <div className={`nav-items ${isMenuOpen ? "active" : ""}`}>
        <ul className="nav-items-list">
          {/* Conditionally render Home item */}
          {location.pathname !== "/landing" && (
            <li className="nav-item" onClick={() => navigate("/landing")}>Home</li>
          )}
          {/* Show Dashboard for logged-in users */}
          {isTokenValid && location.pathname !== "/" && (
            <li className="nav-item" onClick={() => navigate("/")}>Dashboard</li>
          )}
          <li className="nav-item" onClick={() => navigate("/about-us")}>About</li>
          <li className="nav-item" onClick={() => navigate("/services")}>Services</li>
          <li className="nav-item" onClick={() => navigate("/how-it-works")}>How It Works</li>
          <li className="nav-item" onClick={() => navigate("/testimonials")}>Testimonials</li>
          <li className="nav-item" onClick={() => navigate("/contact-us")}>Contact Us</li>
          {/* Conditionally render Login item */}
          {/* {!isTokenValid && location.pathname !== "/login" && (
            <li className="nav-item login" onClick={() => navigate("/login")}>Login</li>
          )} */}
        </ul>
          {/* Conditionally render Sign Up button on Home page if token does not exist */}
      </div>
      <div>
          {location.pathname === "/landing" && !isTokenValid && (
            <button className="nav-item signup" onClick={() => navigate("/signup")}>Sign Up</button>
          )}
                    {location.pathname === "/landing" && !isTokenValid && (
            <button className="nav-item login" onClick={() => navigate("/login")}>Login</button>
          )}

          </div>
  
      {isTokenValid ? (
        <Dropdown overlay={menu} trigger={['click']}>
          <div className="user-menu">
            <span className="username">{username}</span>
            <img src={UserImg} alt="user" className="dummy-icon" /> {/* Placeholder for user icon */}
          </div>
        </Dropdown>
      ) : (
        <span></span>
      )}
    </div>
  );
};

export default Header;
